import { Box } from "@mui/material";
import CustomShimmer from "../../../components/CustomShimmer/CustomShimmer";
import { Colors } from "../../../styles/constant";

const CenterBannerSkeleton = () => {
  return (
    <Box display="flex" flexDirection="column" rowGap="16px">
      <Box
        display="flex"
        flexDirection="column"
        columnGap=".5rem"
        rowGap="1rem"
        padding="1rem 1.25rem"
        borderRadius="1.5rem"
        sx={{
          backgroundColor: { xs: Colors.white, md: Colors.bgGray },
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box flex={1}>
            <CustomShimmer width="70%" height="1rem" borderRadius=".25rem" />
            <Box
              display="flex"
              flexDirection="column"
              rowGap=".5rem"
              marginTop="1rem"
            >
              <CustomShimmer
                width="50%"
                height="1rem"
                borderRadius=".4375rem"
              />
              <CustomShimmer
                width="40%"
                height="1rem"
                borderRadius=".4375rem"
              />
            </Box>
          </Box>
          <CustomShimmer width="2rem" height="2rem" borderRadius="1.5rem" />
        </Box>
      </Box>
    </Box>
  );
};

export default CenterBannerSkeleton;
